import React, { useState } from 'react';
import { strings } from 'src/localization';
import classNames from 'classnames';
import * as css from './eApproval.module.scss';
import { IView, Link, LoadingProgress } from '@framework-controls/core';
import { IconWarning, IconCheckMark } from 'src/content/icons';
import { ComponentMapIds } from 'src/components/map';

export interface IProps {
    total: number;
    approved: number;
    declined: number;
    link: string;
    name: string;
    fetchROs: (customerNum: string, roNum?: string) => void;
    setLoadingROs: (loadingROs: boolean) => void;
    custId: string;
    currentRO: string | undefined;
    loadingROs: boolean;
    mainPaneViewOrder: IView[];
    setSendLog: React.Dispatch<React.SetStateAction<boolean>>;
}

const EApproval = (props: IProps) => {
    const [selectedRO, setSelectedRO] = useState('');

    const lastPane = props.mainPaneViewOrder[props.mainPaneViewOrder.length - 1];
    window.onfocus = () => {
        if (lastPane.viewId === ComponentMapIds.VehLayout) {
            if (props.approved === 0 && props.declined === 0) {
                props.setLoadingROs(true);
                if (props.currentRO && props.currentRO !== '-1') {
                    props.fetchROs(props.custId, props.currentRO);
                    setSelectedRO(props.currentRO);
                    props.setSendLog(false);
                } else {
                    props.fetchROs(props.custId, selectedRO);
                    props.setSendLog(false);
                }
            }
        }
    };

    const descriptionClasses = classNames(
        css.description,
        {
            [css.marginBottom]: props.approved + props.declined === 0,
        },
    );
    const approvedDeclinedClasses = classNames(
        css.approvedDeclined,
        {
            [css.marginBottom]: props.approved + props.declined > 0,
        },
    );
    const currentRepairCardClasses = classNames(
        css.currentRepairCard,
        {
            [css.warningBorder]: props.approved + props.declined === 0,
            [css.actionTakenBorder]: props.approved + props.declined > 0,
            [css.loadingProgress]: props.loadingROs,
        },
    );
    let approvedDeclined: JSX.Element | null = null;
    let description = (
        <span>
            <span>{props.name + strings.WeFound}</span>
            <span className={css.bold}>{props.total.toString()}</span>
            <span>{props.total > 1 ? strings.ItemsInspectionAttention : strings.ItemInspectionAttention}</span>
        </span>);
    let icon = <IconWarning className={css.warning} />;
    if (props.approved + props.declined > 0) {
        approvedDeclined = (
            <div className={approvedDeclinedClasses}>
                <span className={css.bold}>{props.approved}</span><span>{strings.Approved}</span>
                <span className={css.bold}>{props.declined}</span><span>{strings.Declined}</span>
            </div>
        );
        icon = <IconCheckMark className={css.check} />;
    }
    if (props.approved + props.declined === props.total) {
        description = (
            <span>
                <span>{props.name + strings.WeFound}</span>
                <span className={css.bold}>{props.total.toString()}</span>
                <span>{props.total > 1 ? strings.ItemsInspectionAttention : strings.ItemInspectionAttention}</span>
            </span>);
    }

    const eApproval = props.loadingROs ?
        (
            <div className={currentRepairCardClasses}>
                <LoadingProgress/>
            </div>
        ) :
        (<div className={currentRepairCardClasses}>
            {icon}
            <span className={css.title}>{strings.InspectionResults}</span>
            <p className={descriptionClasses}>{description}</p>
            {approvedDeclined}
            <div className={css.link}>
                <Link
                    id='ReyPAYLink'
                    url={props.link}
                    onClick={() => window.open(props.link)}
                >
                    <span className={css.label}>{strings.ViewResults}</span>
                </Link>
            </div>
        </div>
        );

    return eApproval;
};


export default EApproval;
